import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 486.000000 486.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,486.000000) scale(0.100000,-0.100000)">

<path d="M0 4845 c0 -13 277 -15 2430 -15 2153 0 2430 2 2430 15 0 13 -277 15
-2430 15 -2153 0 -2430 -2 -2430 -15z"/>
<path d="M2747 3529 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M2800 3530 c0 -5 4 -10 8 -10 7 0 41 -28 108 -90 12 -11 27 -20 33
-20 6 0 -8 17 -31 38 -24 20 -45 39 -48 42 -20 20 -70 49 -70 40z"/>
<path d="M2715 3490 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2810 3487 c0 -2 18 -18 40 -36 48 -39 53 -34 8 8 -29 27 -48 38 -48
28z"/>
<path d="M2740 3475 c0 -2 10 -10 23 -16 20 -11 21 -11 8 4 -13 16 -31 23 -31
12z"/>
<path d="M2720 3453 c8 -3 25 -15 38 -26 12 -11 22 -18 22 -14 0 13 -44 47
-59 46 -14 0 -14 -1 -1 -6z"/>
<path d="M2822 3424 c10 -10 20 -16 22 -13 3 3 -5 11 -17 18 -21 13 -21 12 -5
-5z"/>
<path d="M2914 3391 c16 -17 16 -19 0 -25 -9 -3 -14 -12 -10 -21 3 -9 -1 -15
-10 -15 -12 0 -15 6 -10 24 6 24 -17 56 -31 42 -3 -3 -1 -6 5 -6 6 0 10 -9 9
-20 -1 -19 -17 -29 -17 -11 0 5 -8 12 -17 15 -10 3 -2 -8 17 -24 19 -17 41
-30 50 -30 24 0 47 22 54 52 5 22 3 25 -14 21 -11 -3 -20 0 -20 6 0 6 -5 11
-12 11 -6 0 -4 -8 6 -19z"/>
<path d="M2675 3390 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2750 3375 c7 -8 17 -15 22 -15 6 0 5 7 -2 15 -7 8 -17 15 -22 15 -6
0 -5 -7 2 -15z"/>
<path d="M2710 3373 c0 -5 12 -16 28 -25 15 -9 42 -32 60 -51 l34 -35 -26 -41
c-15 -22 -31 -41 -38 -41 -6 0 -1 11 12 25 45 48 13 34 -35 -15 -27 -28 -44
-50 -38 -50 6 0 14 6 17 13 3 6 5 3 3 -7 -2 -21 -51 -34 -62 -16 -3 5 1 10 10
10 12 0 9 7 -11 25 -15 14 -31 25 -37 25 -6 0 0 -8 11 -19 39 -33 16 -46 -23
-13 -12 9 -4 0 18 -20 22 -21 49 -38 60 -38 23 0 159 139 153 157 -3 6 0 13 7
16 13 4 -17 57 -33 57 -15 0 -12 -17 5 -24 8 -3 15 -10 15 -16 0 -6 -7 -5 -20
2 -11 7 -20 19 -20 26 0 7 -8 15 -17 19 -10 3 -30 15 -45 25 -16 11 -28 16
-28 11z"/>
<path d="M2998 3269 c-10 -5 -36 -36 -57 -68 -81 -119 -229 -221 -363 -251
l-57 -13 -30 32 c-19 21 -38 31 -58 31 -33 0 -73 -25 -73 -46 0 -9 -10 -14
-28 -14 -51 0 -209 64 -265 108 -36 28 -130 125 -160 165 -24 31 -34 37 -66
37 -49 0 -75 -28 -96 -105 -61 -229 -1 -484 157 -659 143 -158 319 -236 532
-236 156 1 286 41 411 127 50 34 150 144 190 208 112 181 137 415 64 616 -25
68 -60 92 -101 68z m-1098 -188 c43 -52 137 -125 208 -159 28 -15 52 -30 52
-35 0 -4 -16 -15 -36 -23 -56 -24 -114 -64 -177 -124 -32 -30 -62 -56 -67 -58
-10 -4 -42 81 -60 157 -15 63 -8 227 11 280 10 28 14 31 23 19 6 -8 27 -34 46
-57z m1140 -13 c22 -131 -6 -329 -56 -387 -2 -2 -22 16 -46 39 -57 57 -144
121 -196 144 -47 21 -52 32 -19 41 53 17 163 95 225 162 37 40 70 73 74 73 3
0 12 -33 18 -72z m-650 -467 c0 -160 -3 -242 -10 -246 -15 -9 -85 66 -113 122
-38 76 -87 247 -87 304 0 19 116 57 177 58 l32 1 1 -239z m238 210 c47 -17 47
-17 45 -62 -7 -138 -101 -351 -174 -390 -18 -9 -19 -2 -19 237 l0 247 51 -7
c28 -4 71 -15 97 -25z m-523 -119 c12 -72 47 -178 81 -246 l35 -68 -28 6 c-50
13 -135 70 -200 134 -35 35 -63 67 -63 71 0 26 144 156 161 145 5 -2 11 -21
14 -42z m754 -20 c39 -38 71 -75 71 -82 0 -37 -193 -189 -261 -205 l-25 -6 37
78 c21 43 48 119 60 168 28 118 27 115 38 115 5 0 41 -31 80 -68z"/>
<path d="M2556 3223 c-3 -3 6 -12 20 -20 31 -15 34 -16 34 -5 0 11 -46 32 -54
25z"/>
<path d="M2488 3213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2408 3203 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M2438 3183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2476 3164 c-5 -14 -4 -15 9 -4 17 14 19 20 6 20 -5 0 -12 -7 -15
-16z"/>
<path d="M2425 3150 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2530 3145 c7 -8 20 -15 29 -15 9 0 26 -9 39 -18 l24 -18 -22 -37
c-24 -40 -28 -42 -50 -26 -12 9 -12 10 3 5 11 -4 17 -2 15 5 -5 16 -88 63 -88
51 0 -6 14 -15 32 -21 41 -15 29 -26 -14 -13 -56 17 -97 22 -103 12 -4 -6 12
-10 38 -10 32 0 54 -7 83 -28 22 -16 45 -27 53 -24 8 3 11 0 7 -7 -13 -21 33
-12 54 11 21 23 23 31 14 63 -5 19 -67 70 -85 70 -4 0 -11 3 -15 8 -14 14 -26
7 -14 -8z m98 -104 c-7 -12 -16 -21 -20 -21 -10 0 3 33 16 42 17 11 18 2 4
-21z"/>
<path d="M2550 3105 c7 -8 16 -13 20 -10 5 3 10 -1 13 -7 2 -7 8 -10 12 -5 10
8 -23 36 -44 37 -11 0 -11 -3 -1 -15z"/>
<path d="M2390 3100 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M2355 3080 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2315 3060 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2348 3043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M764 2067 c-3 -8 -4 -126 -2 -263 l3 -249 136 -3 c132 -2 137 -2 189
25 69 37 105 83 126 162 36 142 -28 284 -145 326 -58 20 -299 22 -307 2z m299
-84 c48 -28 67 -75 67 -166 0 -146 -38 -184 -185 -188 l-90 -2 -3 179 c-1 98
0 185 3 193 8 21 165 8 208 -16z"/>
<path d="M2270 2068 c0 -9 110 -446 126 -500 4 -14 16 -18 48 -18 l42 0 62
198 c33 108 64 209 68 225 3 15 9 29 13 32 4 2 39 -98 78 -223 l71 -227 43 -3
44 -3 64 253 c35 139 66 259 69 266 3 10 -4 13 -29 10 -33 -3 -34 -3 -56 -93
-12 -49 -35 -144 -52 -210 -17 -66 -31 -128 -31 -137 0 -44 -18 -8 -52 105
-20 67 -51 170 -69 230 l-33 107 -42 0 -42 0 -37 -117 c-21 -65 -53 -169 -71
-231 -32 -113 -44 -142 -44 -108 0 10 -20 100 -45 199 -71 283 -62 257 -95
257 -17 0 -30 -5 -30 -12z"/>
<path d="M3680 1815 l0 -265 30 0 30 0 0 265 0 265 -30 0 -30 0 0 -265z"/>
<path d="M4080 1978 l0 -102 -31 32 c-38 38 -63 46 -130 40 -98 -10 -144 -74
-144 -203 0 -100 26 -154 90 -185 70 -34 139 -26 193 23 l22 20 0 -26 c0 -23
4 -27 30 -27 l30 0 0 265 0 265 -30 0 -30 0 0 -102z m-66 -88 c44 -16 66 -65
66 -145 0 -110 -38 -155 -128 -155 -88 0 -125 53 -120 171 3 81 18 111 63 130
28 11 89 11 119 -1z"/>
<path d="M1715 2028 c-2 -7 -5 -26 -7 -43 -3 -26 -8 -31 -38 -35 -32 -5 -35
-8 -35 -40 0 -32 3 -35 33 -38 l32 -3 0 -113 c0 -62 5 -126 10 -143 15 -42 57
-63 129 -63 64 0 62 -2 65 55 1 17 -7 21 -54 25 l-55 5 -3 117 -3 117 58 3 58
3 0 35 0 35 -57 3 -57 3 -3 42 c-3 39 -5 42 -36 45 -20 2 -34 -2 -37 -10z"/>
<path d="M1347 1929 c-43 -23 -77 -71 -77 -111 0 -26 3 -28 39 -28 36 0 39 2
45 35 6 30 12 36 46 45 28 8 52 8 80 0 34 -9 40 -15 46 -45 3 -18 3 -38 0 -43
-3 -5 -41 -13 -83 -17 -136 -13 -183 -45 -183 -125 0 -105 156 -137 253 -52
16 14 17 13 17 -11 0 -25 3 -27 40 -27 l40 0 0 143 c0 161 -10 195 -69 234
-45 30 -139 31 -194 2z m183 -228 c0 -52 -53 -91 -123 -91 -62 0 -90 39 -51
70 28 24 174 41 174 21z"/>
<path d="M2023 1934 c-39 -17 -83 -79 -83 -116 0 -26 3 -28 40 -28 32 0 40 4
40 18 0 52 59 81 129 62 35 -9 41 -15 47 -46 3 -19 4 -37 1 -40 -3 -3 -36 -10
-73 -15 -103 -14 -139 -26 -168 -55 -43 -44 -35 -116 18 -152 54 -37 148 -27
201 21 20 18 20 18 23 -7 3 -23 8 -26 43 -26 l39 0 0 142 c0 166 -14 212 -75
241 -43 21 -137 21 -182 1z m172 -257 c-11 -40 -40 -60 -98 -65 -41 -3 -57 0
-70 13 -39 39 -11 65 87 80 39 7 75 9 79 5 4 -4 5 -19 2 -33z"/>
<path d="M3085 1936 c-38 -17 -70 -48 -92 -89 -23 -42 -23 -160 0 -203 71
-136 276 -136 338 0 37 82 19 208 -37 257 -55 48 -146 63 -209 35z m169 -65
c46 -43 57 -170 19 -229 -32 -52 -128 -67 -184 -29 -44 29 -62 83 -56 160 8
92 52 129 145 124 37 -3 59 -10 76 -26z"/>
<path d="M3380 1751 l0 -201 30 0 30 0 0 149 c0 135 2 151 21 175 16 21 29 26
63 26 49 0 73 -19 78 -65 2 -24 8 -31 31 -33 25 -3 27 -1 27 37 0 31 -7 49
-31 76 -28 31 -37 35 -79 35 -37 0 -55 -6 -79 -25 l-30 -26 -3 23 c-2 17 -11
24 -30 26 l-28 3 0 -200z"/>
<path d="M2211 1314 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2107 1297 c-2 -7 -1 -32 2 -57 5 -38 10 -45 31 -48 22 -3 23 -2 9
10 -22 17 -30 66 -13 76 11 6 9 10 -5 19 -15 9 -20 9 -24 0z"/>
<path d="M1232 1278 c-15 -15 -15 -61 0 -76 7 -7 22 -12 34 -12 24 0 50 25 36
34 -6 3 -12 -1 -16 -9 -14 -38 -62 -1 -52 40 7 28 43 35 52 10 4 -8 10 -15 15
-15 6 0 5 9 -1 20 -12 22 -49 27 -68 8z"/>
<path d="M1368 1265 c-17 -38 3 -75 40 -75 40 0 61 39 42 75 -9 18 -22 25 -42
25 -21 0 -32 -7 -40 -25z m70 -21 c3 -33 -14 -49 -43 -38 -31 12 -14 77 19 72
15 -2 22 -11 24 -34z"/>
<path d="M1519 1281 c-5 -36 -4 -73 3 -83 4 -8 8 4 8 30 0 73 55 67 63 -6 3
-25 4 -21 3 13 l-1 50 -37 1 c-21 1 -38 -2 -39 -5z"/>
<path d="M1678 1283 c-13 -3 -18 -15 -18 -43 0 -54 18 -60 22 -8 2 35 7 43 23
43 16 0 21 -8 23 -35 5 -49 22 -63 22 -18 0 65 -14 76 -72 61z"/>
<path d="M1822 1278 c-7 -7 -12 -24 -12 -38 0 -14 5 -31 12 -38 17 -17 53 -15
68 3 15 18 7 19 -20 3 -15 -9 -22 -10 -31 -1 -17 17 -3 32 27 28 30 -3 42 18
24 40 -15 18 -51 20 -68 3z m56 -15 c2 -9 -7 -13 -28 -13 -28 0 -31 2 -20 15
15 18 41 16 48 -2z"/>
<path d="M1964 1277 c-3 -8 -4 -30 -2 -49 3 -30 6 -33 38 -33 26 0 36 5 38 19
4 19 3 19 -13 2 -10 -9 -24 -15 -32 -12 -8 3 -17 6 -19 6 -6 0 -5 36 2 54 8
21 33 20 51 -1 13 -17 14 -17 11 2 -4 25 -65 35 -74 12z"/>
<path d="M2213 1240 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z"/>
<path d="M2290 1240 c0 -29 2 -51 4 -49 8 8 10 88 3 95 -4 4 -7 -17 -7 -46z"/>
<path d="M2332 1284 c17 -5 22 -16 32 -74 2 -14 3 -2 2 25 -1 46 -3 50 -26 52
-14 1 -18 0 -8 -3z"/>
<path d="M2434 1263 c-8 -30 5 -56 30 -61 15 -3 15 -1 -3 17 -12 12 -21 25
-21 30 0 14 28 33 40 26 5 -3 10 -1 10 4 0 6 -11 11 -25 11 -18 0 -26 -7 -31
-27z"/>
<path d="M2500 1230 c0 -51 -3 -60 -18 -60 -10 0 -23 5 -30 12 -9 9 -12 8 -12
-4 0 -20 37 -30 62 -17 14 8 18 22 18 69 0 33 -4 60 -10 60 -6 0 -10 -27 -10
-60z"/>
<path d="M2660 1286 c0 -4 8 -30 17 -58 16 -43 16 -50 3 -58 -13 -8 -13 -10 1
-10 10 0 23 18 34 48 10 26 22 51 26 57 11 11 12 25 1 25 -4 0 -14 -16 -21
-35 -13 -37 -31 -47 -31 -17 0 18 -29 65 -30 48z"/>
<path d="M2800 1265 c-16 -42 5 -75 48 -75 31 0 49 41 34 75 -16 35 -69 35
-82 0z m70 0 c24 -28 -9 -72 -45 -59 -15 6 -21 55 -8 67 11 12 40 8 53 -8z"/>
<path d="M2954 1245 l1 -50 40 0 40 0 1 43 c1 23 -2 45 -7 48 -5 3 -9 -13 -9
-35 0 -44 -10 -56 -40 -46 -14 4 -20 17 -23 48 -4 37 -4 36 -3 -8z"/>
<path d="M3177 1281 c-2 -3 -2 -12 -1 -18 1 -7 3 -28 4 -45 3 -29 4 -28 9 12
5 37 10 46 28 48 23 3 25 -2 37 -68 2 -14 3 -2 2 25 l-1 50 -38 1 c-21 1 -39
-2 -40 -5z"/>
<path d="M3328 1265 c-17 -39 3 -75 42 -75 23 0 33 6 42 25 17 39 -3 75 -42
75 -23 0 -33 -6 -42 -25z m70 -21 c3 -33 -15 -49 -43 -38 -18 7 -20 60 -2 67
26 12 42 1 45 -29z"/>
<path d="M3471 1268 c-1 -32 15 -78 28 -78 5 0 15 16 21 35 14 43 23 44 35 3
15 -47 31 -45 44 6 14 55 14 59 1 51 -5 -3 -10 -19 -10 -36 0 -40 -16 -37 -31
6 -15 42 -30 41 -43 -3 -12 -42 -20 -40 -33 6 -9 32 -11 34 -12 10z"/>
<path d="M1006 1211 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4
-12 2 -15 -3z"/>
<path d="M1076 1211 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4
-12 2 -15 -3z"/>
<path d="M1150 1205 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"/>
<path d="M3660 1205 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"/>
<path d="M3730 1204 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z"/>
<path d="M3800 1204 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
